import React, { useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AppSuspense from './components/AppSuspense';
import { ThemeProviderCustom } from './contexts/theme-context';
import { defaultTheme } from './utility/theme';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const SurveyForm = React.lazy(() => import('./pages/SurveyForm'));

const App: React.FC = () => {
  const [count, setCount] = useState(0);
  return (
    <ThemeProviderCustom theme={defaultTheme}>
      <AppSuspense>
        <Router>
          <Routes>
            <Route path="/f/:hash" element={<SurveyForm />} />
            <Route path="*" element={<Navigate to="/f/0" replace />} />
          </Routes>
        </Router>
      </AppSuspense>
    </ThemeProviderCustom>
  );
};

export default App;
